import { authClient, API } from "../index";
import { safeGet } from "../../utils/safeGet";
import axios from "axios";

export const getEventById = (id) => {
  return safeGet(`${API}/event/${id}`);
};

/**
 * Obtener información del cliente sin pedir permisos
 */
const getClientInfo = () => {
  try {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const screenWidth = window.screen.width;
    const screenHeight = window.screen.height;
    const browserLanguage = navigator.language || navigator.userLanguage;
    
    // Detectar tipo de dispositivo
    let deviceType = 'unknown';
    const ua = navigator.userAgent.toLowerCase();
    if (/(tablet|ipad|playbook|silk)|(android(?!.*mobile))/i.test(ua)) {
      deviceType = 'tablet';
    } else if (/mobile|iphone|ipod|android|blackberry|opera|mini|windows\sce|palm|smartphone|iemobile/i.test(ua)) {
      deviceType = 'mobile';
    } else {
      deviceType = 'desktop';
    }
    
    return {
      timezone,
      screenWidth,
      screenHeight,
      deviceType,
      browserLanguage,
    };
  } catch (error) {
    console.error("Error obteniendo información del cliente:", error);
    return {};
  }
};

export const getEventByQrCode = async (qrCode) => {
  // Obtener información del cliente
  const clientInfo = getClientInfo();
  
  try {
    // Usar POST para enviar la información del cliente
    const response = await axios.post(`${API}/event/qr/${qrCode}`, {
      clientInfo
    }, {
      withCredentials: true,
    });
    return response;
  } catch (error) {
    // El servidor ya contestó (404 si el QR no es de un evento, 410 si el
    // negocio está inhabilitado): repetir por GET daría lo mismo y tarda más
    if (error.response && error.response.status !== 405) {
      return { status: error.response.status, data: error.response.data };
    }
    // Si falla POST, intentar con GET (fallback para compatibilidad)
    return safeGet(`${API}/event/qr/${qrCode}`);
  }
};


